import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Common files
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';

// Authentication & Protection
import ProtectedRoute from './components/ProtectedRoute';

// Public Pages
import Home from './pages/masini-in-rate-buzau';
import Stock from './pages/Stock';
import CarDetails from './pages/CarDetails';
import Contact from './pages/Contact';

// Admin Pages
import AdminLogin from './components/admin/AdminlLogin';
import Admin from './pages/Admin';
import CarForm from './components/admin/CarForm';

// Termeni si Conditii

import Termeni from './pages/Termeni';
import Politica from './pages/Politica';


function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Navbar />
        <Routes>
          {/* ========== PAGINI PUBLICE ========== */}
          <Route path="/" element={<Home />} />
          <Route path="/stock" element={<Stock />} />
          <Route path="/masini" element={<Stock />} />

          {/* ========== Termeni si Conditii ========== */}
          <Route path="/termeni" element={<Termeni />} />
          <Route path="/politica" element={<Politica />} />
          
          {/* 🔧 SCHIMBAT DIN :slug ÎN :id */}
          <Route path="/masini/:id" element={<CarDetails />} />
          
          <Route path="/contact" element={<Contact />} />

          {/* ========== ADMIN LOGIN (PUBLIC) ========== */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* ========== RUTE ADMIN PROTEJATE ========== */}
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/dashboard" 
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/masini/nou" 
            element={
              <ProtectedRoute>
                <CarForm />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/masini/edit/:id" 
            element={
              <ProtectedRoute>
                <CarForm />
              </ProtectedRoute>
            } 
          />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;